const sourceColorMap = {
  'Daily update': 'icon.success',
  'Monthly update': 'icon.success',
  Multiple: 'icon.success',
  'Under review': 'icon.info',
  'Need action': 'icon.info',
  Excluded: 'neutral.400',
  'No longer exists': 'neutral.400',
  'No job source': 'neutral.400',
  // TODO: Remove above once new statuses are live
  Off: 'neutral.400',
  Unavailable: 'neutral.400',
  Live: 'icon.success',
  'In Setup': 'icon.info',
  'In Review': 'icon.amber',
};

export default sourceColorMap;
